import React from "react";
import S from "./Title.style";

type Props = {
  title1?: string;
  backgroundColor?: string;
  titleAccent?: string;
  title2?: string;
  title?: string;
  fontSize?: string;
};

const Title = ({
  title,
  title1,
  titleAccent,
  title2,
  backgroundColor,
  fontSize,
}: Props) => {
  if (!backgroundColor) {
    backgroundColor = "white";
  }

  if (fontSize === "h1") {
    return (
      <S.H1Title backgroundColor={backgroundColor}>
        {title && title}
        {title1 && title1}
        {titleAccent && <S.AccentTitle> {titleAccent} </S.AccentTitle>}
        {title2 && title2}
      </S.H1Title>
    );
  } else if (fontSize === "h2") {
    return (
      <S.H2Title backgroundColor={backgroundColor}>
        {title && title}
        {title1 && title1}
        {titleAccent && <S.AccentTitle> {titleAccent} </S.AccentTitle>}
        {title2 && title2}
        <S.Line backgroundColor={backgroundColor} />
      </S.H2Title>
    );
  } else
    return (
      <S.H3Title backgroundColor={backgroundColor}>
        {title && title}
        {title1 && title1}
        {titleAccent && <S.AccentTitle> {titleAccent} </S.AccentTitle>}
        {title2 && title2}
        <S.Line backgroundColor={backgroundColor} />
      </S.H3Title>
    );
};

export default Title;
